
import '@hotwired/turbo-rails';
import { start } from '@nerdgeschoss/shimmer';
import { application } from '../controllers/application';
import "../../assets/stylesheets/application.scss";
import { registerControllers } from 'stimulus-vite-helpers';
import "chartkick/chart.js"

import.meta.glob('../sprinkles/**/*', { eager: true });

const controllers = import.meta.glob('../**/*_controller.{ts,js}', {
  eager: true,
});
registerControllers(application, controllers);

start({ application });
